import { ShareType } from 'app/lib/types/server';
import { UNEXPECTED_FAILURE, TIMEOUT } from 'app/store/__generated__/errors';

export const translation = {
    Websocket: {
        lostConnection: "Connection lost. Will try to reconnect in {{seconds}} $t(common:periods.second, {'count': {{seconds}} }).",
        serviceFailed: '{{service}} has failed. It is recommended this be resolved before continuing any further work.',
        retry: 'Try now.'
    },
    AccessDenied: {
        title: 'Sorry, access denied!',
        body: "You don't have permission to see this asset's details page."
    },

    // Custom UI errors
    DeploymentOutOfSync: 'Deployment is out-of-sync and should be redeployed.',
    Shares: {
        [ShareType.EMAIL]: {
            [UNEXPECTED_FAILURE]: 'Unknown error during email preparation for share with ID {{shareId}}, please contact support.',
            [TIMEOUT]: 'Email preparation timed out for share with ID {{shareId}}, please contact support.'
        },
        [ShareType.GOOGLE_SHEETS]: {
            [UNEXPECTED_FAILURE]: 'Unknown error during Google Sheets sync for share with ID {{sharedId}}, please contact support.',
            [TIMEOUT]: 'Google Sheets sync timed out for share with ID {{shareId}}, please contact support.'
        }
    },

    // response mappings (no specific error payload available)
    PayloadTooLarge: 'The submitted payload is too large.',
    UnprocessableEntity: '{{- message}}',
    ServerError: '{{- message}}',
    UnmappedResponseCode: 'Unexpected {{code}} response: {{- message}}',
    ClientSideError: 'Client side error: {{- message}}',
    ModelOutOfSync: 'Model is out-of-sync and should be redeployed.',
    UploadAborted: 'The upload was aborted.'
};
